import api from '@/api/API';
import { AccountSettings } from '@/types';
import isGranted from '@/auth/isGranted';

export default {
  find(accountId: string): Promise<AccountSettings> {
    if (!isGranted('FIND_ACCOUNT_SETTINGS')) return Promise.reject();
    return api
      .get(`/accounts/${accountId}/settings`)
      .then(response => response.data);
  },
  async getApiKey(accountId: string): Promise<string|null> {
    return this.find(accountId).then(settings => settings.apiKey);
  },
};
